import React from 'react';
import PropTypes from 'prop-types';
import GeneralDialogLayout from '@Containers/Dialogs/GeneralDialogLayout/GeneralDialogLayout';
import RouteThumbnailsFullTreeContainer from '@Pages/RetroSynthesis/RouteTree/RouteThumbnailsFullTreeContainer';
import Button from '@Components/Button';
import { RsRoute } from '@Pages/RetroSynthesis/routes';
import { useRouteMatch } from 'react-router-dom';

import './RouteThumbnailsPopup.theme.scss';

export const RouteThumbnailsPopUpFooter = ({ path, onClick }) => (
  <div className="route-thumbnail-popup__footer">
    <Button
      onClick={onClick}
      buttonConfig={{
        href: `#${path}`,
        aTag: true,
        label: 'Tree view',
        type: 'link',
        size: 'sm',
        e2eName: 'project-route-tree-view',
      }}
      iconConfig={{
        position: 'after',
        name: 'chevron-right',
      }}
    />
  </div>
);

const RouteThumbnailsPopup = ({ tree, routeName, routeId, selfClose, ...rest }) => {
  const match = useRouteMatch(RsRoute.PROJECT);
  const { projectId } = match && match.params || {};
  const treeViewPath = RsRoute.getProjectRouteTreeViewLink(projectId, routeId);

  return (
    <GeneralDialogLayout
      {...rest}
      selfClose={selfClose}
      size={'sm'}
      movable={false}
      className="react-dialogs-scrollable route-overview-tree-popup"
      header={
        <h4>{routeName}</h4>
      }
      footer={
        <RouteThumbnailsPopUpFooter path={treeViewPath} onClick={selfClose}/>
      }
    >
      <div className="route-thumbnail-popup route-overview-tree-popup__container">
        <RouteThumbnailsFullTreeContainer
          tree={tree}
        />
      </div>
    </GeneralDialogLayout>
  );
};

RouteThumbnailsPopup.propTypes = {
  treeList: PropTypes.array,
};

export const typeOfRouteThumbnailDialog = 'typeOfRouteThumbnailDialog';
export default RouteThumbnailsPopup;
